var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.$route.query.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }